export const FieldLabels: Record<string, string> = {
    companyName: 'Название компании',
    inn: 'ИНН',
    location: 'Фактическое местонахождение компании',
    fio: 'ФИО',
    phone: 'Телефон',
    email: 'Электронная почта',
};
